import React, { useEffect } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { useDispatch, useSelector } from 'react-redux';
import actions from './actions';
import { selectors } from '.';

const useStyles = makeStyles((theme: any) => ({
  globalLoadingIndicatorLoaderContainer: {
    backgroundColor: 'rgba(0,0,0,0.3)',
    minHeight: '100vh',
    position: 'fixed',
    zIndex: 6969,
  },
  globalLoadingIndicatorColorPrimary: {
    color: `${theme.palette.primary.main}`,
  },
}));

const GlobalLoadingIndicator = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const count = useSelector(selectors.selectCount);

  useEffect(() => {
    const axiosRequestListener = axios.interceptors.request.use(
      (config) => {
        dispatch(actions.addCount());
        return config;
      },
      (error) => {
        dispatch(actions.subtractCount());
        return Promise.reject(error);
      }
    );
    const axiosResponseListener = axios.interceptors.response.use(
      (response) => {
        dispatch(actions.subtractCount());
        return response;
      },
      (error) => {
        dispatch(actions.subtractCount());
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.request.eject(axiosRequestListener);
      axios.interceptors.request.eject(axiosResponseListener);
    };
  }, []);

  return count > 0 ? (
    <Grid
      container
      spacing={0}
      direction='column'
      alignItems='center'
      justifyContent='center'
      className={classes.globalLoadingIndicatorLoaderContainer}
    >
      <Grid item xs={3}>
        <CircularProgress size={60} classes={{ colorPrimary: classes.globalLoadingIndicatorColorPrimary }} />
      </Grid>
    </Grid>
  ) : null;
};

GlobalLoadingIndicator.defaultProps = {
  count: 0,
};

export default GlobalLoadingIndicator;
